export default __webpack_public_path__ + "static/media/fax.0bea3fba.svg";